import { MobileMutations, MobileState } from './types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<MobileState> = {
  [MobileMutations.SetCompanyCode](state: MobileState, code: { id: number; code: string }) {
    state.companyCode = code;
  },
};
